export const REGION_LIST_COUNT = 5;

export const REGION_DEFAULT_CATEGORY = "topstories";

// THE REGIONS ORDERING MATTER FOR NEWS/LOCAL
export const REGIONS_LIST = [
    {
        id: 43,
        preference: "bc",
        title: "British Columbia",
        link: "/news/canada/british-columbia",
        path: "news/canada/british-columbia",
        trendingSection: "britishcolumbia",
        cookieName: "bc",
        province: "British Columbia",
        categorySlug: "british-columbia",
        thumbnail:
            "https://i.cbc.ca/1.4211244!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_1180/image-.jpg",
        liveRadioRegion: "Vancouver",
        navigation: [
            {
                link: "/news/canada/british-columbia",
                title: "Home",
                type: "internal",
            },
            {
                link: "/news/canada/british-columbia/community",
                title: "Community",
                type: "internal",
                isCommunity: true,
            },
            {
                link: "/news/canada/british-columbia/british-columbia-programs-1.4024048",
                title: "Programs",
                type: "internal",
            },
            {
                link: "/news/canada/british-columbia/contact-us-1.3982389",
                title: "Contact Us",
                type: "internal",
            },
            {
                link: "/news/gopublic",
                title: "Go Public",
                type: "internal",
            },
            {
                link: "https://www.cbc.ca/weather/s0000141.html",
                title: "Weather",
                type: "external",
            },
            {
                link: "/news/canada/british-columbia/local",
                title: "B.C. Locals",
                type: "internal",
            },
        ],
    },
    {
        id: 45,
        preference: "calgary",
        title: "Calgary",
        link: "/news/canada/calgary",
        path: "news/canada/calgary",
        trendingSection: "calgary",
        province: "Alberta",
        categorySlug: "calgary",
        thumbnail:
            "https://i.cbc.ca/1.4211426!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_1180/image-.jpg",
        liveRadioRegion: "Calgary",
        navigation: [
            {
                link: "/news/canada/calgary",
                title: "Home",
                type: "internal",
            },
            {
                link: "/news/canada/calgary/community",
                title: "Community",
                type: "internal",
                isCommunity: true,
            },
            {
                link: "/news/canada/calgary/calgary-programs-1.4024212",
                title: "Programs",
                type: "internal",
            },
            {
                link: "/news/canada/calgary/cbc-calgary-contact-page-1.3847658",
                title: "Contact Us",
                type: "internal",
            },
            {
                link: "https://www.cbc.ca/weather/s0000047.html",
                title: "Weather",
                type: "external",
            },
        ],
    },
    {
        id: 46,
        preference: "edmonton",
        title: "Edmonton",
        link: "/news/canada/edmonton",
        path: "news/canada/edmonton",
        trendingSection: "edmonton",
        province: "Alberta",
        categorySlug: "edmonton",
        thumbnail:
            "https://i.cbc.ca/1.4211440!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_780/edmonton.jpg",
        liveRadioRegion: "Edmonton",
        navigation: [
            {
                link: "/news/canada/edmonton",
                title: "Home",
                type: "internal",
            },
            {
                link: "/player/news/canada/edmonton",
                title: "Video",
                type: "internal",
            },
            {
                link: "/news/canada/edmonton/community",
                title: "Community",
                type: "internal",
                isCommunity: true,
                discoverContent: true,
            },
            {
                link: "/news/canada/edmonton/edmonton-programs-1.4024299",
                title: "Programs",
                type: "internal",
            },
            {
                link: "/news/canada/edmonton/contact-cbc-edmonton-1.4020009",
                title: "Contact Us",
                type: "internal",
            },
            {
                link: "/learning-english",
                title: "Learning English",
                type: "internal",
            },
            {
                link: "/player/news/canada/edmonton/our-edmonton",
                title: "Our Edmonton",
                type: "internal",
            },
            {
                link: "https://www.cbc.ca/weather/s0000045.html",
                title: "Weather",
                type: "external",
            },
        ],
    },
    {
        id: 47,
        preference: "sask",
        title: "Saskatchewan",
        link: "/news/canada/saskatchewan",
        path: "news/canada/saskatchewan",
        trendingSection: "saskatchewan",
        cookieName: "sask",
        province: "Saskatchewan",
        categorySlug: "saskatchewan",
        thumbnail:
            "https://i.cbc.ca/1.4211450!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_1180/image-.jpg",
        liveRadioRegion: "Regina",
        navigation: [
            {
                link: "/news/canada/saskatchewan",
                title: "Home",
                type: "internal",
            },
            {
                link: "/news/canada/saskatchewan/community/this-is-sk-1.7347397",
                title: "This is Saskatchewan: Podcast",
                type: "internal",
            },
            {
                link: "/news/canada/saskatchewan/community",
                title: "Community",
                type: "internal",
                isCommunity: true,
            },
            {
                link: "/news/canada/saskatchewan/saskatchewan-programs-1.4024364",
                title: "Programs",
                type: "internal",
            },
            {
                link: "/player/news/canada/saskatchewan",
                title: "Video",
                type: "internal",
            },
            {
                link: "/news/canada/saskatchewan/contact-cbc-saskatchewan-regina-saskatoon-1.3961906",
                title: "Contact Us",
                type: "internal",
            },
            {
                link: "https://www.cbc.ca/weather/s0000788.html",
                title: "Weather",
                type: "external",
            },
        ],
    },
    {
        id: 48,
        preference: "saskatoon",
        title: "Saskatoon",
        link: "/news/canada/saskatoon",
        path: "news/canada/saskatoon",
        trendingSection: "saskatoon",
        province: "Saskatchewan",
        categorySlug: "saskatoon",
        thumbnail:
            "https://i.cbc.ca/1.4211457!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_1180/image-.jpg",
        liveRadioRegion: "Saskatoon",
        navigation: [
            {
                link: "/news/canada/saskatoon",
                title: "Home",
                type: "internal",
            },
            {
                link: "/news/canada/saskatchewan/community/this-is-sk-1.7347397",
                title: "This is Saskatchewan: Podcast",
                type: "internal",
            },
            {
                link: "/news/canada/saskatoon/community",
                title: "Community",
                type: "internal",
                isCommunity: true,
            },
            {
                link: "/news/canada/saskatoon/saskatoon-programs-1.4024416",
                title: "Programs",
                type: "internal",
            },
            {
                link: "/player/news/canada/saskatoon",
                title: "Video",
                type: "internal",
            },
            {
                link: "/news/canada/saskatoon/contact-cbc-saskatoon-1.3962520",
                title: "Contact Us",
                type: "internal",
            },
            {
                link: "https://www.cbc.ca/weather/s0000797.html",
                title: "Weather",
                type: "external",
            },
        ],
    },
    {
        id: 49,
        preference: "manitoba",
        title: "Manitoba",
        link: "/news/canada/manitoba",
        path: "news/canada/manitoba",
        trendingSection: "manitoba",
        province: "Manitoba",
        categorySlug: "manitoba",
        thumbnail:
            "https://i.cbc.ca/1.4211460!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_1180/image-.jpg",
        liveRadioRegion: "Winnipeg",
        navigation: [
            {
                link: "/news/canada/manitoba",
                title: "Home",
                type: "internal",
            },
            {
                link: "/news/canada/manitoba/community",
                title: "Community",
                type: "internal",
                isCommunity: true,
            },
            {
                link: "/news/canada/manitoba/manitoba-programs-1.4024431",
                title: "Programs",
                type: "internal",
            },
            {
                link: "/player/news/canada/manitoba",
                title: "Video",
                type: "internal",
            },
            {
                link: "/news/canada/manitoba/contact-us-information-manitoba-1.3930903",
                title: "Contact Us",
                type: "internal",
            },
            {
                link: "https://www.cbc.ca/weather/s0000193.html",
                title: "Weather",
                type: "external",
            },
        ],
    },
    {
        id: 50,
        preference: "thunderbay",
        title: "Thunder Bay",
        link: "/news/canada/thunder-bay",
        path: "news/canada/thunder-bay",
        trendingSection: "thunderbay",
        province: "Ontario",
        thumbnail:
            "https://i.cbc.ca/1.4211467!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_1180/image-.jpg",
        cookieName: "thunderbay",
        categorySlug: "thunder-bay",
        liveRadioRegion: "Thunder Bay",
        navigation: [
            {
                link: "/news/canada/thunder-bay",
                title: "Home",
                type: "internal",
            },
            {
                link: "/news/canada/thunder-bay/thunder-bay-programs-1.4024474",
                title: "Programs",
                type: "internal",
            },
            {
                link: "/news/canada/thunder-bay/contacting-cbc-thunder-bay-1.4127705",
                title: "Contact Us",
                type: "internal",
            },
            {
                link: "https://www.cbc.ca/weather/s0000411.html",
                title: "Weather",
                type: "external",
            },
        ],
    },
    {
        id: 51,
        preference: "sudbury",
        title: "Sudbury",
        link: "/news/canada/sudbury",
        path: "news/canada/sudbury",
        trendingSection: "sudbury",
        province: "Ontario",
        categorySlug: "sudbury",
        thumbnail:
            "https://i.cbc.ca/1.4211469!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_1180/image-.jpg",
        liveRadioRegion: "Sudbury",
        navigation: [
            {
                link: "/news/canada/sudbury",
                title: "Home",
                type: "internal",
            },
            {
                link: "/news/canada/sudbury/sudbury-programs-1.4024511",
                title: "Programs",
                type: "internal",
            },
            {
                link: "/news/canada/sudbury/sudbury-cbc-contact-us-1.3960113",
                title: "Contact Us",
                type: "internal",
            },
            {
                link: "https://www.cbc.ca/weather/s0000680.html",
                title: "Weather",
                type: "external",
            },
        ],
    },
    {
        id: 52,
        preference: "windsor",
        title: "Windsor",
        link: "/news/canada/windsor",
        path: "news/canada/windsor",
        trendingSection: "windsor",
        province: "Ontario",
        categorySlug: "windsor",
        thumbnail:
            "https://i.cbc.ca/1.4211470!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_1180/image-.jpg",
        liveRadioRegion: "Windsor",
        navigation: [
            {
                link: "/news/canada/windsor",
                title: "Home",
                type: "internal",
            },
            {
                link: "https://www.cbc.ca/listen/shows/windsor-morning",
                title: "Windsor Morning",
                type: "external",
            },
            {
                link: "https://www.cbc.ca/listen/shows/afternoon-drive",
                title: "Afternoon Drive",
                type: "external",
            },
            {
                link: "/player/news/canada/windsor",
                title: "CBC Windsor News At 6",
                type: "internal",
            },
            {
                link: "/news/canada/windsor/cbc-windsor-contact-us-1.4003398",
                title: "Contact Us",
                type: "internal",
            },
            {
                link: "https://www.cbc.ca/weather/s0000646.html",
                title: "Weather",
                type: "external",
            },
        ],
    },
    {
        id: 100,
        preference: "london",
        title: "London",
        link: "/news/canada/london",
        path: "news/canada/london",
        discover: "news/canada/london/southwestsounds",
        trendingSection: "london",
        cookieName: "london",
        province: "Ontario",
        categorySlug: "london",
        thumbnail:
            "https://i.cbc.ca/1.4211473!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_1180/image-.jpg",
        liveRadioRegion: "London",
        navigation: [
            {
                link: "/news/canada/london",
                title: "Home",
                type: "internal",
            },
            {
                link: "https://www.cbc.ca/listen/shows/london-morning",
                title: "London Morning",
                type: "external",
            },
            {
                link: "https://www.cbc.ca/listen/shows/afternoon-drive",
                title: "Afternoon Drive",
                type: "external",
            },
            {
                link: "/news/canada/london/cbc-london-contact-us-1.4151393",
                title: "Contact Us",
                type: "internal",
            },
            {
                link: "https://www.cbc.ca/weather/s0000326.html",
                title: "Weather",
                type: "external",
            },
        ],
    },
    {
        id: 53,
        preference: "kitchener-waterloo",
        title: "Kitchener-Waterloo",
        link: "/news/canada/kitchener-waterloo",
        path: "news/canada/kitchener-waterloo",
        trendingSection: "kitchenerwaterloo",
        categorySlug: "kitchener-waterloo",
        province: "Ontario",
        thumbnail:
            "https://i.cbc.ca/1.4211474!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_460/image-.jpg",
        liveRadioRegion: "Kitchener-Waterloo",
        navigation: [
            {
                link: "/news/canada/kitchener-waterloo",
                title: "Home",
                type: "internal",
            },
            {
                link: "/news/canada/kitchener-waterloo/about-us-contact-cbc-kitchener-waterloo-891-fm-1.3960034",
                title: "Contact Us",
                type: "internal",
            },
            {
                link: "/news/canada/kitchener-waterloo/topic/Tag/Guelph%20News",
                title: "Guelph News",
                type: "internal",
            },
            {
                link: "https://www.cbc.ca/weather/s0000573.html",
                title: "Weather",
                type: "external",
            },
        ],
    },
    {
        id: 54,
        preference: "hamilton",
        title: "Hamilton",
        link: "/news/canada/hamilton",
        path: "news/canada/hamilton",
        trendingSection: "hamilton",
        province: "Ontario",
        categorySlug: "hamilton",
        thumbnail:
            "https://i.cbc.ca/1.4211477!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_1180/image-.jpg",
        liveRadioRegion: "Toronto",
        navigation: [
            {
                link: "/news/canada/hamilton",
                title: "Home",
                type: "internal",
            },
            {
                link: "/news/canada/hamilton/contact-cbc-hamilton-1.3622559",
                title: "Contact Us",
                type: "internal",
            },
            {
                link: "https://www.cbc.ca/weather/s0000549.html",
                title: "Weather",
                type: "external",
            },
        ],
    },
    {
        id: 55,
        preference: "toronto",
        title: "Toronto",
        link: "/news/canada/toronto",
        path: "news/canada/toronto",
        trendingSection: "toronto",
        province: "Ontario",
        categorySlug: "toronto",
        thumbnail:
            "https://i.cbc.ca/1.4211224!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_1180/image-.jpg",
        liveRadioRegion: "Toronto",
        navigation: [
            {
                link: "/news/canada/toronto",
                title: "Home",
                type: "internal",
            },
            {
                link: "/news/canada/toronto/community",
                title: "Community",
                type: "internal",
                isCommunity: true,
            },
            {
                link: "/news/canada/toronto/toronto-programs-1.4024640",
                title: "Programs",
                type: "internal",
            },
            {
                link: "/news/canada/toronto/cbc-toronto-contact-us-1.3558446",
                title: "Contact Us",
                type: "internal",
            },
            {
                link: "https://www.cbc.ca/listen/shows/metro-morning",
                title: "Metro Morning",
                type: "external",
            },
            {
                link: "https://www.cbc.ca/weather/s0000458.html",
                title: "Weather",
                type: "external",
            },
        ],
    },
    {
        id: 56,
        preference: "ottawa",
        title: "Ottawa",
        link: "/news/canada/ottawa",
        path: "news/canada/ottawa",
        trendingSection: "ottawa",
        province: "Ontario",
        categorySlug: "ottawa",
        thumbnail:
            "https://i.cbc.ca/1.4211479!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_1180/image-.jpg",
        liveRadioRegion: "Ottawa",
        navigation: [
            {
                link: "/news/canada/ottawa",
                title: "Home",
                type: "internal",
            },
            {
                link: "/news/canada/ottawa/community",
                title: "Community",
                type: "internal",
                isCommunity: true,
            },
            {
                link: "/news/canada/ottawa/ottawa-programs-1.4024706",
                title: "Programs",
                type: "internal",
            },
            {
                link: "/news/canada/ottawa/cbc-ottawa-contact-us-1.3982028",
                title: "Contact Us",
                type: "internal",
            },
            {
                link: "https://www.cbc.ca/weather/s0000430.html",
                title: "Weather",
                type: "external",
            },
        ],
    },
    {
        id: 57,
        preference: "montreal",
        title: "Montreal",
        link: "/news/canada/montreal",
        path: "news/canada/montreal",
        trendingSection: "montreal",
        province: "Québec",
        categorySlug: "montreal",
        thumbnail:
            "https://i.cbc.ca/1.4211486!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_1180/image-.jpg",
        liveRadioRegion: "Montreal",
        navigation: [
            {
                link: "/news/canada/montreal",
                title: "Home",
                type: "internal",
            },
            {
                link: "/news/canada/montreal/community",
                title: "Community",
                type: "internal",
                isCommunity: true,
            },
            {
                link: "/news/canada/montreal/montreal-programs-1.4024745",
                title: "Programs",
                type: "internal",
            },
            {
                link: "/news/canada/montreal/cbc-montreal-contact-list-story-ideas-tips-1.3368463",
                title: "Contact Us",
                type: "internal",
            },
            {
                link: "https://www.cbc.ca/weather/s0000635.html",
                title: "Weather",
                type: "external",
            },
        ],
    },
    {
        id: 58,
        preference: "nb",
        title: "New Brunswick",
        link: "/news/canada/new-brunswick",
        path: "news/canada/new-brunswick",
        trendingSection: "newbrunswick",
        province: "New Brunswick",
        categorySlug: "new-brunswick",
        thumbnail:
            "https://i.cbc.ca/1.4211490!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_1180/image-.jpg",
        cookieName: "nb",
        liveRadioRegion: "Fredericton",
        navigation: [
            {
                link: "/news/canada/new-brunswick",
                title: "Home",
                type: "internal",
            },
            {
                link: "/news/canada/new-brunswick/community",
                title: "Community",
                type: "internal",
                isCommunity: true,
            },
            {
                link: "/news/canada/new-brunswick/new-brunswick-programs-1.4024808",
                title: "Programs",
                type: "internal",
            },
            {
                link: "/news/canada/new-brunswick/cbc-new-brunswick-contact-us-1.4008641",
                title: "Contact Us",
                type: "internal",
            },
            {
                link: "https://www.cbc.ca/weather/s0000250.html",
                title: "Weather",
                type: "external",
            },
        ],
    },
    {
        id: 59,
        preference: "pei",
        title: "Prince Edward Island",
        shortTitle: "PEI",
        link: "/news/canada/prince-edward-island",
        path: "news/canada/prince-edward-island",
        trendingSection: "pei",
        categorySlug: "pei",
        province: "Prince Edward Island",
        thumbnail:
            "https://i.cbc.ca/1.4211491!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_1180/image-.jpg",
        cookieName: "pei",
        liveRadioRegion: "Charlottetown",
        navigation: [
            {
                link: "/news/canada/prince-edward-island",
                title: "Home",
                type: "internal",
            },
            {
                link: "/news/canada/prince-edward-island/community",
                title: "Community",
                type: "internal",
                isCommunity: true,
            },
            {
                link: "/news/canada/prince-edward-island/prince-edward-island-programs-1.4024869",
                title: "Programs",
                type: "internal",
            },
            {
                link: "/news/canada/prince-edward-island/cbc-pei-contact-us-1.3970879",
                title: "Contact Us",
                type: "internal",
            },
            {
                link: "https://www.cbc.ca/weather/s0000583.html",
                title: "Weather",
                type: "external",
            },
        ],
    },
    {
        id: 60,
        preference: "ns",
        title: "Nova Scotia",
        link: "/news/canada/nova-scotia",
        path: "news/canada/nova-scotia",
        trendingSection: "novascotia",
        cookieName: "ns",
        categorySlug: "nova-scotia",
        province: "Nova Scotia",
        thumbnail:
            "https://i.cbc.ca/1.4211498!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_1180/image-.jpg",
        liveRadioRegion: "Halifax",
        navigation: [
            {
                link: "/news/canada/nova-scotia",
                title: "Home",
                type: "internal",
            },
            {
                link: "/news/canada/nova-scotia/community",
                title: "Community",
                type: "internal",
                isCommunity: true,
            },
            {
                link: "/news/canada/nova-scotia/nova-scotia-programs-1.4024900",
                title: "Programs",
                type: "internal",
            },
            {
                link: "/news/canada/nova-scotia/cbc-nova-scotia-contact-us-1.3983812",
                title: "Contact Us",
                type: "internal",
            },
            {
                link: "https://www.cbc.ca/weather/s0000318.html",
                title: "Weather",
                type: "external",
            },
            {
                link: "/news/canada/nova-scotia/ryan-snoddon-live-blog-weather-1.3532467",
                title: "Ryan Snoddon",
                type: "internal",
            },
        ],
    },
    {
        id: 61,
        preference: "nl",
        title: "Newfoundland & Labrador",
        shortTitle: "NL",
        link: "/news/canada/newfoundland-labrador",
        path: "news/canada/newfoundland-labrador",
        trendingSection: "newfoundland",
        cookieName: "nl",
        province: "Newfoundland & Labrador",
        categorySlug: "nl",
        thumbnail:
            "https://i.cbc.ca/1.4211503!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_1180/image-.jpg",
        liveRadioRegion: "St. John's",
        navigation: [
            {
                link: "/news/canada/newfoundland-labrador",
                title: "Home",
                type: "internal",
            },
            {
                link: "/news/canada/newfoundland-labrador/community",
                title: "Community",
                type: "internal",
                isCommunity: true,
            },
            {
                link: "/news/canada/newfoundland-labrador/newfoundland-labrador-programs-1.4024957",
                title: "Programs",
                type: "internal",
            },
            {
                link: "/news/canada/newfoundland-labrador/contact-us-cbcnl-1.3990861",
                title: "Contact Us",
                type: "internal",
            },
            {
                link: "https://www.cbc.ca/weather/s0000280.html",
                title: "Weather",
                type: "external",
            },
        ],
    },
    {
        id: 62,
        preference: "north",
        title: "North",
        link: "/news/canada/north",
        path: "news/canada/north",
        trendingSection: "north",
        province: "North",
        categorySlug: "north",
        thumbnail:
            "https://i.cbc.ca/1.4211508!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_1180/image-.jpg",
        liveRadioRegion: "Whitehorse",
        navigation: [
            {
                link: "/news/canada/north",
                title: "Home",
                type: "internal",
            },
            {
                link: "/news/canada/north/topic/Location/Yukon",
                title: "Yukon",
                type: "internal",
            },
            {
                link: "/news/canada/north/topic/Location/Northwest%20Territories",
                title: "Northwest Territories",
                type: "internal",
            },
            {
                link: "/news/canada/north/topic/Location/Nunavut",
                title: "Nunavut",
                type: "internal",
            },
            {
                link: "/news/canada/north/topic/Location/Northern%20Quebec",
                title: "Northern Quebec",
                type: "internal",
            },
            {
                link: "/news/canada/north/cbc-north-contact-us-1.3982681",
                title: "Contact Us",
                type: "internal",
            },
            {
                link: "/news/canada/north/community",
                title: "Community",
                type: "internal",
                isCommunity: true,
            },
            {
                link: "/news/canada/north/north-programs-1.4025022",
                title: "Programs",
                type: "internal",
            },
            {
                link: "https://www.cbc.ca/weather/s0000275.html",
                title: "Dawson City Weather",
                type: "external",
            },
            {
                link: "https://www.cbc.ca/weather/s0000825.html",
                title: "Whitehorse Weather",
                type: "external",
            },
            {
                link: "https://www.cbc.ca/weather/s0000519.html",
                title: "Inuvik Weather",
                type: "external",
            },
            {
                link: "https://www.cbc.ca/weather/s0000648.html",
                title: "Watson Lake Weather",
                type: "external",
            },
            {
                link: "https://www.cbc.ca/weather/s0000561.html",
                title: "Hay River Weather",
                type: "external",
            },
            {
                link: "https://www.cbc.ca/weather/s0000366.html",
                title: "Yellowknife Weather",
                type: "external",
            },
            {
                link: "https://www.cbc.ca/weather/s0000495.html",
                title: "Cambridge Bay Weather",
                type: "external",
            },
            {
                link: "https://www.cbc.ca/weather/s0000678.html",
                title: "Rankin Inlet Weather",
                type: "external",
            },
            {
                link: "https://www.cbc.ca/weather/s0000394.html",
                title: "Iqaluit Weather",
                type: "external",
            },
        ],
    },
    {
        id: 44,
        preference: "kamloops",
        title: "Kamloops",
        link: "/news/canada/kamloops",
        path: "news/canada/kamloops",
        trendingSection: "",
        hideInNav: true,
        province: "British Columbia",
        categorySlug: "kamloops",
        thumbnail:
            "https://i.cbc.ca/1.4211422!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_300/image-.jpg",
        liveRadioRegion: "Kamloops",
        navigation: [
            {
                link: "/news/canada/kamloops",
                title: "Home",
                type: "internal",
            },
            {
                link: "/news/canada/kamloops/contact-cbc-kamloops-1.4012428",
                title: "Contact Us",
                type: "internal",
            },
            {
                link: "https://www.cbc.ca/bc/weather/s0000568.html",
                title: "Weather",
                type: "external",
            },
        ],
    },
];

const defaultRegion = REGIONS_LIST.find(
    (regionName) => regionName.preference === "ottawa"
);

export const DEFAULT_REGION = {
    title: defaultRegion.title,
    path: defaultRegion.path,
    id: defaultRegion.id,
    trendingSection: defaultRegion.trendingSection,
    categorySlug: defaultRegion.categorySlug,
    preference: defaultRegion.preference,
    listenLive: defaultRegion.liveRadioRegion,
};

export const generateRegion = (props = {}) => ({ ...DEFAULT_REGION, ...props });
export const REGION_BY_PREFERENCE = REGIONS_LIST.reduce((accum, region) => {
    const key = region.preference;
    accum[key] = generateRegion(region);
    return accum;
}, {});
